<template>
  <v-dialog :value="value != null" persistent max-width="1100px" :attach="true">
    <v-card style="padding: 0px">
      <v-card-title>
        Edit Detached Page
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4" v-if="localPage">
        <elwrapper label="Title" midtext>
          <f-textarea v-model="localPage.title" rows="3" />
          <div class="caption grey--text mt-1">
            Optional: first line = smaller intro, following lines = main title
          </div>
        </elwrapper>
        <elwrapper label="Type" midtext>
          <div class="body-2">{{ typeLabel }}</div>
        </elwrapper>
        <elwrapper label="Content" midtext>
          <ProgramPageContentEditor
            :title="localPage.title"
            :type="localPage.type"
            :value="localPage.content"
            @input="onContentChange"
          />
        </elwrapper>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <g-button label="Cancel" @onclick="close" />
        <v-spacer></v-spacer>
        <g-button label="Save" type="primary" @onclick="save" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ProgramPageContentEditor, pageTypeLabel, normalizePageContent, clonePageContent } from "@/modules/program_pages";

export default {
  components: {
    ProgramPageContentEditor,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      localPage: null,
    };
  },
  computed: {
    typeLabel() {
      return pageTypeLabel(this.localPage?.type);
    },
  },
  methods: {
    close() {
      this.$emit("input", null);
    },
    onContentChange(content) {
      if (!this.localPage) return;
      this.localPage = {
        ...this.localPage,
        content: normalizePageContent(this.localPage.type, content),
      };
    },
    save() {
      if (!this.localPage) return;
      this.$emit("save", {
        index: this.value.index,
        page: {
          mode: "detached",
          sourcePageId: this.localPage.sourcePageId || null,
          title: this.localPage.title,
          type: this.localPage.type,
          content: normalizePageContent(this.localPage.type, this.localPage.content),
        },
      });
      this.close();
    },
  },
  watch: {
    value: {
      handler(val) {
        if (!val?.page) {
          this.localPage = null;
          return;
        }
        this.localPage = {
          ...val.page,
          content: clonePageContent(normalizePageContent(val.page.type, val.page.content)),
        };
      },
      immediate: true,
    },
  },
};
</script>
